import { isNil } from 'lodash';
import { CSSProperties } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { DateRangeField } from '@shared/data/entity/fields/DateRangeField';
import { getPartialFormattedDateTimeRangeParts } from '@shared/util/date';
import { i18n } from '@shared/util/i18n';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: DateRangeField;
  style: StyleProp<ViewStyle>;
  textStyle?: CSSProperties;
}

export function DateRangeCollectionViewField({ field, style, textStyle }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={style}>
      <FormattedDateRange field={field} textStyle={textStyle} />
    </CardCollectionViewFieldContainer>
  );
}

export function FormattedDateRange({
  field,
  textStyle,
}: {
  field: DateRangeField;
  textStyle?: CSSProperties;
}) {
  const { start, end } = field.dateRange;
  const { from, to } = getPartialFormattedDateTimeRangeParts(start, end);
  return (
    <View row wrap gap={0.75}>
      <FormattedDateRangePart
        text={from}
        placeholder={i18n('workflowTemplate.component.dateRange.startPlaceholder')}
        textStyle={textStyle}
      />
      <Text size="body1" style={textStyle}>
        –
      </Text>
      <FormattedDateRangePart
        text={to}
        placeholder={i18n('workflowTemplate.component.dateRange.endPlaceholder')}
        textStyle={textStyle}
      />
    </View>
  );
}

function FormattedDateRangePart({
  text,
  placeholder,
  textStyle,
}: {
  text?: string;
  placeholder: string;
  textStyle?: CSSProperties;
}) {
  const isPlaceholder = isNil(text);
  return (
    <Text size="body1" inactive={isPlaceholder} style={textStyle}>
      {text ?? placeholder}
    </Text>
  );
}
